import React from 'react';
import PropTypes from 'prop-types';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import BuilderPageProvider from 'admin/containers/BuilderPageProvider';
import AddOnsEditor from 'components/sections/AddOns/AddOnsEditor';
import Page from '../containers/Page';
import { AdminLayout, BuilderPageHeader, AdminNavbar } from '../../../layout';
import ComponentLibrary from './ComponentLibrary';

export default class AdminPageBuilder extends React.Component {
  static propTypes = {
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
    pageType: PropTypes.string,
    presentPage: PropTypes.object,
    showComponentLibrary: PropTypes.bool.isRequired,
    onToggleComponentLibrary: PropTypes.func.isRequired,
    isSectionDragging: PropTypes.bool.isRequired,
    revise: PropTypes.func,
    saveVersion: PropTypes.func,
    sources: PropTypes.array,
    onSectionStartDragging: PropTypes.func.isRequired,
    onSectionStopDragging: PropTypes.func.isRequired,
    onWidgetStartDragging: PropTypes.func.isRequired,
    onWidgetStopDragging: PropTypes.func.isRequired,
    accessEnterpriseOptions: PropTypes.bool.isRequired,
    accessRentalCenterOptions: PropTypes.bool.isRequired,
  };

  state = {
    showPopUpModal: false,
  };

  onShowPopupModal = (id, { type }) => {
    const key = `show${type}Modal`;
    this.setState({ [key]: true });
  };

  onHidePopupModal = (type) => {
    const key = `show${type}Modal`;
    this.setState({ [key]: false });
  };

  render() {
    const {
      pageType,
      presentPage,
      revise,
      saveVersion,
      onSectionStartDragging,
      onSectionStopDragging,
      onWidgetStartDragging,
      onWidgetStopDragging,
      onToggleComponentLibrary,
      showComponentLibrary,
      isSectionDragging,
      params,
      sources,
      accessEnterpriseOptions,
      accessRentalCenterOptions,
      ...rest
    } = this.props;

    // If we don't have a page type, something is wrong
    if (!pageType) {
      return false;
    }

    const currentPageId = params.id;

    const header = (
      <BuilderPageHeader />
    );

    const add = {
      text: 'Add Section / Widget',
      onClick: onToggleComponentLibrary,
      authorization: null,
      active: showComponentLibrary,
    };

    const panel = (
      <ComponentLibrary
        {...rest}
        pageType={pageType}
        presentPage={presentPage}
        revise={revise}
        saveVersion={saveVersion}
        onSectionStartDragging={onSectionStartDragging}
        onSectionStopDragging={onSectionStopDragging}
        onWidgetStartDragging={onWidgetStartDragging}
        onWidgetStopDragging={onWidgetStopDragging}
        onToggleComponentLibrary={onToggleComponentLibrary}
        onShowPopupModal={this.onShowPopupModal}
        show={showComponentLibrary}
        accessEnterpriseOptions={accessEnterpriseOptions}
        accessRentalCenterOptions={accessRentalCenterOptions}
      />
    );

    const navbar = (
      <AdminNavbar
        add={add}
        panel={panel}
      />
    );

    return (
      <BuilderPageProvider id={currentPageId}>
        <DndProvider backend={HTML5Backend}>
          <AdminLayout header={header} navbar={navbar}>
            <Page
              id={currentPageId}
              showSectionPlaceholders={isSectionDragging}
              onShowPopupModal={this.onShowPopupModal}
              onHidePopupModal={this.onHidePopupModal}
            />
            <AddOnsEditor
              showPopUpModal={this.state.showPopUpModal}
              onClosePopUpModal={this.onHidePopupModal}
              presentPage={presentPage}
              revise={revise}
              saveVersion={saveVersion}
              sources={sources}
            />
          </AdminLayout>

        </DndProvider>
      </BuilderPageProvider>
    );
  }
}
